<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.1502 19.5H26.6815C27.0842 19.5001 27.4705 19.6533 27.7552 19.9259C28.04 20.1986 28.2 20.5683 28.2 20.9539V24.3461C28.2 24.7317 28.04 25.1015 27.7552 25.3742C27.4703 25.6468 27.084 25.8 26.6812 25.8H24.15V19.5002L24.1502 19.5Z"
      fill="#CACBCC"
    />
    <path
      d="M26.7 25.8016C26.3121 25.8015 25.9402 25.6474 25.6659 25.3731C25.3917 25.0988 25.2376 24.7269 25.2376 24.339V15.5641C25.2376 15.1762 25.0835 14.8042 24.8092 14.5299C24.5349 14.2557 24.1629 14.1016 23.775 14.1016H20.85V25.8016H26.7Z"
      fill="#535456"
    />
    <path
      d="M23.7 14.1016C23.3121 14.1016 22.9401 14.2549 22.6658 14.5277C22.3915 14.8006 22.2374 15.1707 22.2374 15.5566V27.1967C22.2374 27.5826 22.0833 27.9526 21.8091 28.2254C21.5348 28.4982 21.1629 28.6515 20.7751 28.6516H17.85V14.1016H23.7Z"
      fill="#CACBCC"
    />
    <path
      d="M20.85 28.6516H3.26567C3.07322 28.6516 2.88266 28.6138 2.70485 28.5403C2.52704 28.4668 2.36548 28.3591 2.22938 28.2234C2.09327 28.0876 1.9853 27.9263 1.91163 27.7489C1.83796 27.5715 1.80002 27.3813 1.79999 27.1892V2.81414C1.79999 2.62207 1.83789 2.43188 1.91154 2.25444C1.98518 2.07699 2.09313 1.91575 2.22921 1.77994C2.36528 1.64413 2.52683 1.5364 2.70463 1.46289C2.88242 1.38939 3.07298 1.35156 3.26543 1.35156H17.9191C18.3078 1.35156 18.6805 1.50565 18.9553 1.77994C19.2302 2.05423 19.3845 2.42624 19.3845 2.81414V27.1892C19.3846 27.5771 19.539 27.949 19.8139 28.2233C20.0887 28.4975 20.4614 28.6516 20.85 28.6516Z"
      fill="#EDEEF0"
    />
    <path
      d="M13.8 9.41948C13.3671 9.00105 12.8527 8.66921 12.2864 8.44304C11.7201 8.21687 11.113 8.10082 10.5 8.10157V12.6016L13.8 9.41948Z"
      fill="#EF5249"
    />
    <path
      d="M13.682 9.45312L10.5 12.5469L13.8627 15.4531C15.4462 13.7222 15.3671 11.0911 13.682 9.45312Z"
      fill="#FFC119"
    />
    <path
      d="M10.6148 8.10156C9.86956 8.10135 9.13616 8.28611 8.48146 8.639C7.82676 8.99188 7.27161 9.50165 6.86663 10.1218C6.46165 10.742 6.21974 11.4528 6.16297 12.1894C6.10619 12.9261 6.23636 13.6651 6.54159 14.339C6.84683 15.013 7.31741 15.6005 7.91043 16.0479C8.50344 16.4953 9.20001 16.7884 9.9366 16.9004C10.6732 17.0124 11.4263 16.9398 12.1274 16.6893C12.8284 16.4387 13.455 16.0181 13.95 15.4658L10.6148 12.5263V8.1018V8.10156Z"
      fill="#5BADFF"
    />
    <path d="M4.20001 19.5H16.95V21.3H4.20025L4.20001 19.5Z" fill="#CACBCC" />
    <path
      d="M4.20001 23.25H5.18084V24.25H4.20001V23.25ZM6.16166 23.25H16.95V24.25H6.16166V23.25ZM4.20001 25.25H16.95V26.25H4.20025L4.20001 25.25Z"
      fill="#CACBCC"
    />
    <path
      d="M18.0251 1.35156H3.27507C2.88385 1.35156 2.50866 1.49972 2.23203 1.76344C1.9554 2.02717 1.79999 2.38485 1.79999 2.75781V5.10156H19.5V2.75781C19.5 2.38493 19.3446 2.02732 19.0681 1.76361C18.7916 1.4999 18.4165 1.35168 18.0254 1.35156H18.0251Z"
      fill="#535456"
    />
    <path
      d="M3.29999 2.70312H4.19999V3.75312H3.29999V2.70312Z"
      fill="#EF5249"
    />
    <path
      d="M5.10001 2.70312H6.15001V3.75312H5.10001V2.70312Z"
      fill="#FFC119"
    />
    <path
      d="M7.20001 2.70312H8.10001V3.75312H7.20001V2.70312Z"
      fill="#5BADFF"
    />
    <path d="M4.20001 19.5H7.20001V21.3H4.20026L4.20001 19.5Z" fill="#FFC119" />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'IconMenuReporting',
} as DefineComponent
</script>
